import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", { d: "m13.786 4.223 4.317 4.317c.253.253.397.601.397.96s-.144.707-.397.96l-4.318 4.317a1.193 1.193 0 0 1-2.036-.844V11.75H7.251a1.124 1.124 0 0 1-1.125-1.125v-2.25c0-.622.503-1.125 1.125-1.125h4.5V5.067a1.193 1.193 0 0 1 2.036-.844m-7.661-.348h-2.25c-.622 0-1.125.503-1.125 1.125v9c0 .622.503 1.125 1.125 1.125h2.25a1.124 1.124 0 1 1 0 2.25h-2.25A3.376 3.376 0 0 1 .5 14V5a3.376 3.376 0 0 1 3.375-3.375h2.25a1.124 1.124 0 1 1 0 2.25" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.5.5h18v18H.5z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }